/** ຂໍ້ຄວາມ UI ຄຳຂໍເບິກສະຕ໋ອກ — ໃຊ້ຮ່ວມກັນທຸກຫນ້າ */
export const TRANSFER_MENU_TITLE = "ຄຳຂໍເບິກສະຕ໋ອກ";

export const TRANSFER_ITEM_TYPE_LABELS: Record<
  "INGREDIENT" | "RETAIL_VARIANT",
  string
> = {
  INGREDIENT: "ວັດຖຸດິບ",
  RETAIL_VARIANT: "ຕົວແບບ",
};

export function transferItemTypeLabel(
  itemType: "INGREDIENT" | "RETAIL_VARIANT",
): string {
  return TRANSFER_ITEM_TYPE_LABELS[itemType];
}

/** ຂໍ້ຄວາມກວດຈຳນວນອະນຸມັດ (ແທນສັນຍາລັກ ≤ ໃນ UI) */
export const TRANSFER_QTY_APPROVED_RULE =
  "ຕ້ອງຫຼາຍກວ່າ 0 ແລະ ບໍ່ເກີນຈຳນວນທີ່ຂໍ";
